import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseDataService, BaseTabsContainer, DefaultListTabsComponent, ModalService, ModelDataService, NotificationService, QueryParameter, TableContextMenuItem, TabsContainerService, UserService } from 'yt-ng-framework';
import { PojedinacnaEvidencijaPdvView } from './pojedinacna-evidencija-pdv-view';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { FilterWithKomitentComponent } from '../_filters/epdv-filter-with-komitent.component';
import { PojedinacnaEvidencijaPdv } from './pojedinacna-evidencija-pdv';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-pojedinacna-evidencija-pdv-tabs',
  templateUrl: './pojedinacna-evidencija-pdv-tabs.component.html'
})
export class PojedinacnaEvidencijaPdvTabsComponent extends BaseTabsContainer<PojedinacnaEvidencijaPdvView> implements OnInit {

  @ViewChild("defaultList", { static: false }) defaultList: DefaultListTabsComponent<PojedinacnaEvidencijaPdvView>;
  @ViewChild("filterPdv", { static: false }) filterFak: FilterWithKomitentComponent;
  constructor(
    public tabsContainerService: TabsContainerService<PojedinacnaEvidencijaPdvView>,
    protected activatedRoute: ActivatedRoute,
    protected userService: UserService,
    protected baseDataService: BaseDataService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected modalService: ModalService,
    protected translateService: TranslateService,
    protected modelDataService: ModelDataService
  ) {
    super(tabsContainerService, activatedRoute, userService)
   }

  ngOnInit() {
    super.ngOnInit();
  }

  ngAfterViewInit(){
    setTimeout(() => {
      this.filterFak.ApplyFilter();
      this.filterFak.showStatusBox=true;
    }, 0);

    this.defaultList.filterComponent = this.filterFak;
  }

  UpdateList(isSent){
    if(isSent){
      this.filterFak.ApplyFilter();
    }
  }

  OsveziStatus(id, silent) {
    let pojedinanaEvidencijaPdvView: PojedinacnaEvidencijaPdvView = null;
    pojedinanaEvidencijaPdvView = this.defaultList.mainItems.find(x => x.ID === id);

    if (this.defaultList.mainItems.find(x => x.ID === id).OsvezivogStatusa)
    {
      
      let slanjeNovoV2 : boolean = ((pojedinanaEvidencijaPdvView.Godina>=2024 && pojedinanaEvidencijaPdvView.PoreskiPeriodId==1 && pojedinanaEvidencijaPdvView.PeriodId>=9)
            || (pojedinanaEvidencijaPdvView.Godina>=2024 && pojedinanaEvidencijaPdvView.PoreskiPeriodId==2 && pojedinanaEvidencijaPdvView.PeriodId>=15)
            || pojedinanaEvidencijaPdvView.Godina>2024)

      let idParameter = [new QueryParameter("id", id)];

      if (slanjeNovoV2){
        this.baseDataService
        .Get("PojedinacnaEvidencijaPdv", "OsveziStatusV2", idParameter, PojedinacnaEvidencijaPdvView)
        .subscribe((data: PojedinacnaEvidencijaPdvView[]) => {
          if (data != null) this.tabsContainerService.EmitItem(data[0]);
        });
      }
      else{
        this.baseDataService
        .Get("PojedinacnaEvidencijaPdv", "OsveziStatus", idParameter, PojedinacnaEvidencijaPdvView)
        .subscribe((data: PojedinacnaEvidencijaPdvView[]) => {
          if (data != null) this.tabsContainerService.EmitItem(data[0]);
        });
      }
      
    }
    else
    {
      if (!silent)
      {
        //window.alert(["'EDOKUMENT.STATUS.NEMOZEDAOSVEZI'"]);
        this.translateService.get('EDOKUMENT.STATUS.NEMOZEDAOSVEZI')
        .subscribe(translate => {
          window.alert(translate);
        })
      }
    }
  }

  refreshStatus(oldToDays: number) {
    let __this=this;
    var odDana = new Date();
    odDana.setDate(odDana.getDate() - oldToDays);
    this.defaultList.mainItems.forEach(function (value) {
      const jsDate = new Date(
        value["DatumObracuna"]["year"],
        value["DatumObracuna"]["month"] - 1,
        value["DatumObracuna"]["day"]
      );
      if (jsDate > odDana)
      {
        __this.OsveziStatus(value["ID"], true);
      };
    });
  }


  applayFilter(data) {
    this.defaultList.LoadMainItems(true, data);
    // this.filterFak.RefreshStatusClick();
  }

  ContextMenuClicked(contextMenuItem: TableContextMenuItem) {
    if (contextMenuItem.Action == "OsveziStatus") {
      let id: number = contextMenuItem.ID;
      this.OsveziStatus(id, false);
    }

    if (contextMenuItem.Action == "PonistiEvidenciju") {
      let id: number = contextMenuItem.ID;
      this.PonistiEvidenciju(id, false);
    }
  }

  PonistiEvidenciju(id, silent){
    this.baseDataService
      .GetByID("PojedinacnaEvidencijaPdv", id, PojedinacnaEvidencijaPdv)
      .subscribe((item: PojedinacnaEvidencijaPdv) => {
        this.getProvajderGenericName(item.ProvajderID).subscribe(
          (genericName: any) => {
            if (
              genericName == "Docloop_t" ||
              genericName == "Docloop_p" ||
              genericName == "Sef_t" ||
              genericName == "Sef_p"
            ) {
              let idParameter = new QueryParameter("pojedinacnaEvidencijaID", id);             
              
              let ponistiNovoV2 : boolean = ((item.Godina>=2024 && item.PoreskiPeriodId==1 && item.PeriodId>=9)
              || (item.Godina>=2024 && item.PoreskiPeriodId==2 && item.PeriodId>=15)
              || item.Godina>2024)

              this.baseDataService
                .Get("PojedinacnaEvidencijaPdv", ponistiNovoV2 ? "CancelIndividualVatRecordingV2" : "CancelIndividualVatRecordingV1" , [idParameter], null)
                .subscribe(
                  (poruka : any) => {
                  this.translateService
                  .get(['EDOKUMENT.PONISTIPOJEDINACNUEVIDENCIJU.SUCESS'])
                  .subscribe(translate => {
                    setTimeout(()=>{
                      // this.notificationService.success(translate['EDOKUMENT.PONISTIPOJEDINACNUEVIDENCIJU.SUCESS'], poruka);
                      this.toastrService.success(translate['EDOKUMENT.PONISTIPOJEDINACNUEVIDENCIJU.SUCESS'], poruka);
                    }, 0)
                    this.OsveziStatus(id, false);
                  });        
                }
                ,error => {
                  throw error;       
                }
                
                );
              }
            },
            (reason) => {}
            );
            
          })

  }

  getProvajderGenericName(id: number) {
    var parameters = [];
    var provajderId = new QueryParameter();
    provajderId.Name = "id";
    provajderId.Value = id;
    parameters.push(provajderId);

    return this.baseDataService.Get(
      "Provajder",
      "getGenericName",
      parameters,
      null
    );
  }

}


